export const PermissionOptions = [
    { value: "Viewer", label: "View only" },
    { value: "Editor", label: "Edit" },
    { value: "Admin", label: "Admin" }
];

export const AssignPermissionOptions = [
    { value: "CREATE", label: "Create" },
    { value: "Create_self", label: "Create (Self)" },
    { value: "EDIT", label: "Edit" },
    { value: "VIEW", label: "View" },
    { value: "NO_ACCESS", label: "No access" },
];

export const commercialValueList = [
    { value: "$0-$10k", label: "$0-$10k" },
    { value: "$10k-$50k", label: "$10k-$50k" },
    { value: "$50k-$250k", label: "$50k-$250k" },
    { value: "$250k+", label: "$250k+" }
];


export const stageOfDevelopmentValueList = [
    { value: "Pre-clinical", label: "Pre-clinical" },
    { value: "Clinical Stage 1", label: "Clinical Stage 1" },
    { value: "Clinical Stage 2", label: "Clinical Stage 2" },
    { value: "Clinical Stage 3", label: "Clinical Stage 3" },
    { value: "Commercial", label: "Commercial" },
    { value: "Other", label: "Other" },
];



export const tempratureRangeList = [
    { value: "custom", label: "Custom", min: null, max: null },
    { value: "none", label: "None", min: null, max: null },
    { value: "cryogenic", label: "-150°C to -180°C (Cryogenic)", min: -180, max: -150 },
    { value: "ultra_low_freezer", label: "-60°C to -90°C (Ultra low freezer)", min: -90, max: -60 },
    { value: "deep_frozen", label: "-40°C to -20°C (Deep frozen)", min: -40, max: -20 },
    { value: "frozen", label: "-25°C to -15°C (Frozen)", min: -25, max: -15 },
    { value: "refrigerated", label: "2°C to 8°C (Refrigerated)", min: 2, max: 8 },
    { value: "crt", label: "15°C to 25°C (CRT)", min: 15, max: 25 },
    { value: "ambient", label: "15°C to 30°C (Ambient)", min: 15, max: 30 }
];

//this list is used in shipment.jsx of filters
export const filtersList = [
    { id: 1, key: "from_location", label: "Origin" },
    { id: 2, key: "to_location", label: "Destination" },
    { id: 3, key: "status", label: "Shipment status" },
    { id: 4, key: "type", label: "Health status" },
    { id: 5, key: "delivery_status", label: "Delivery status" },
    { id: 6, key: "product", label: "Product" },
    { id: 7, key: "product_type", label: "Product type" },
    { id: 8, key: "project_id", label: "Project ID" },
    { id: 9, key: "scheduled_pickup_date", label: "Scheduled pickup" },
    { id: 10, key: "scheduled_delivery_date", label: "Scheduled delivery" },
    { id: 11, key: "courier", label: "Transport provider" },
    { id: 12, key: "team", label: "Team" },
    { id: 13, key: "link_code", label: "Linked shipments" },
];
 export const gmtToIanaMap = [
    { value: "Etc/GMT-12", label: "(GMT-12:00) Etc/GMT-12" },
    { value: "Pacific/Midway", label: "(GMT-11:00) Pacific/Midway" },
    { value: "Pacific/Honolulu", label: "(GMT-10:00) Pacific/Honolulu" },
    { value: "America/Anchorage", label: "(GMT-09:00) America/Anchorage" },
    { value: "America/Los_Angeles", label: "(GMT-08:00) America/Los_Angeles" },
    { value: "America/Denver", label: "(GMT-07:00) America/Denver" },
    { value: "America/Chicago", label: "(GMT-06:00) America/Chicago" },
    { value: "America/New_York", label: "(GMT-05:00) America/New_York" },
    { value: "America/Toronto", label: "(GMT-04:00) America/Toronto" },
    { value: "America/Argentina/Buenos_Aires", label: "(GMT-03:00) America/Argentina/Buenos_Aires" },
    { value: "Atlantic/South_Georgia", label: "(GMT-02:00) Atlantic/South_Georgia" },
    { value: "Atlantic/Azores", label: "(GMT-01:00) Atlantic/Azores" },
    { value: "Europe/London", label: "(GMT+0:00) Europe/London" },
    { value: "Europe/Berlin", label: "(GMT+01:00) Europe/Berlin" },
    { value: "Europe/Athens", label: "(GMT+02:00) Europe/Athens" },
    { value: "Europe/Moscow", label: "(GMT+03:00) Europe/Moscow" },
    { value: "Asia/Tehran", label: "(GMT+03:30) Asia/Tehran" },
    { value: "Asia/Dubai", label: "(GMT+04:00) Asia/Dubai" },
    { value: "Asia/Kabul", label: "(GMT+04:30) Asia/Kabul" },
    { value: "Asia/Karachi", label: "(GMT+05:00) Asia/Karachi" }, 
    { value: "Asia/Kolkata", label: "(GMT+05:30) Asia/Kolkata" },
    { value: "Asia/Kathmandu", label: "(GMT+05:45) Asia/Kathmandu" },
    { value: "Asia/Dhaka", label: "(GMT+06:00) Asia/Dhaka" },
    { value: "Asia/Yangon", label: "(GMT+06:30) Asia/Yangon" },
    { value: "Asia/Bangkok", label: "(GMT+07:00) Asia/Bangkok" },
    { value: "Asia/Singapore", label: "(GMT+08:00) Asia/Singapore" },
    { value: "Asia/Tokyo", label: "(GMT+09:00) Asia/Tokyo" },
    { value: "Australia/Adelaide", label: "(GMT+09:30) Australia/Adelaide" },
    { value: "Australia/Sydney", label: "(GMT+10:00) Australia/Sydney" },
    { value: "Pacific/Guadalcanal", label: "(GMT+11:00) Pacific/Guadalcanal" },
    { value: "Pacific/Auckland", label: "(GMT+12:00) Pacific/Auckland" },
    { value: "Pacific/Tongatapu", label: "(GMT+13:00) Pacific/Tongatapu" },
    { value: "Pacific/Kiritimati", label: "(GMT+14:00) Pacific/Kiritimati" }
  ];

export const shipmentStatusDDL = [
    { id: "DELAYED", name: "Delayed" },
    // { id: "CRITICAL_ALERT", name: "Critical Alert" },
    { id: "DELIVERED", name: "Delivered" },
    { id: "IN-TRANSIT", name: "In transit" },
    { id: "CANCELLED", name: "Cancelled" },
    { id: "PENDING", name: "Pending" },
    { id: "ARCHIVED", name: "Archived" },
    { id: "AWAITING PICKUP", name: "Awaiting pickup" },

]

export const healthStatusDDL = [
    { id: "0", name: "Critical alert" },
    { id: "1", name: "At risk" },
    { id: "2", name: "On track" },
]

export const deliveryStatusDDL = [
    { id: "On", name: "On time" },
    { id: "Late", name: "Late" },
    { id: "Early", name: "Early" },
    {id:"Unknown",name:"Other"}
]

export const notificationFrequencyOptions = [
    { label: "Real-time", value: "REAL_TIME", extraText: "Send me a notification for every alert" },
    { label: "Batched alerts", value: "BATCHED", extraText: "Send me a single summary of alerts every..." },
];

export const alertCardData = [
    { value: "is_critical", label: "Critical alerts", name: "is_critical" },
    { value: "is_at_risk", label: "At-risk alerts", name: "is_at_risk" },
    { value: "is_pickup_confirmation", label: "Pickup confirmation", name: "is_pickup_confirmation" },
    { value: "is_delivery_confirmation", label: "Delivery confirmation", name: "is_delivery_confirmation" },
];

export const teams = [
    { label: "Internal medicine", value: "internal_medicine", name: "Internal Medicine" },
    { label: "Hospital", value: "hospital", name: "Hospital" },
    { label: "Oncology", value: "oncology", name: "Oncology" },
    { label: "Vaccines", value: "vaccines", name: "Vaccines" },
    { label: "Specialty pharma", value: "specialty_pharma", name: "Specialty Pharma" }
  ];


export const ReportingPeriodList = [
    {label:"Custom",value:"Custom"},
    {label:"Last 7 days",value:"Last 7 days"},
    {label:"Last 30 days",value:"Last 30 days"},
    {label:"Month to date",value:"Month to date"},
    {label:"Quarter to date",value:"Quarter to date"},
    {label:"Year to date",value:"Year to date"},
    {label:"All time",value:"All time"},
    // {label:"December 2024",value:"December 2024"},
    // {label:"November 2024",value:"November 2024"},
    // {label:"October 2024",value:"October 2024"},
]
  
  export const metricsTimePeriod = [
    { value: "month", label: "Per month" },
    { value: "quarter", label: "Per quarter" },
    { value: "year", label: "Per year" },
];

export const sensorIgnoreTime = [
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "30", value: 30 },
    { label: "40", value: 40 },
    { label: "50", value: 50 },
    { label: "60", value: 60 },
    { label: "70", value: 70 },
    { label: "80", value: 80 },
    { label: "90", value: 90 },
    { label: "100", value: 100 },
    { label: "110", value: 110 },
    { label: "120", value: 120 },
  ];
  
  export const HometempratureList = [
    { id: "none", name: "None", color: "#757575" },
    { id: "ambient", name:'-15° to 30°C', name2: "Ambient", color: "#3AA76D" },
    { id: "crt", name:'-15° to 25°C', name2: "CRT", color: "#2B6B46" },
    { id: "refrigerated", name:'2° to 8°C', name2: "Refrigerated", color: "#A9C9FF" },
    { id: "frozen", name:'-25° to -15°C', name2: "Frozen", color: "#6DAAFB" },
    { id: "deep_frozen", name:'-40° to -20°C', name2: "Deep frozen", color: "#266EF1" },
    { id: "ultra_low_freezer", name:'-60° to -90°C', name2: "Ultra low freezer", color: "#1948A3" },
    { id: "cryogenic", name:'-150° to -180°C', name2: "Cryogenic", color: "#002661" }
  ];
  
  export const RiskLevelList = [
    { id: "no_issue", name: "No issue", color: "" },
    { id: "critical", name: "Critical", color: "#CC1031" },
    { id: "at_risk", name: "At-risk", color: "#F6BC2F" },
  ];
  